import { useOrionSettings } from '@vimeo/orion';

export const useNewIPSPanelAssignment = () => {
  const { settings } = useOrionSettings();
  return settings.in_product_support_panel;
};
